import type { PrimeVuePTOptions } from 'primevue/config'
import type { PassThrough } from '@primevue/core'

const PrimeVuePT: PassThrough<PrimeVuePTOptions> = {
  tablist: ({ instance }) => ({
    activeBar: () => {
      return {
        // Opravuje dynamicky počet tabů
        style: `width:${100 / instance.$slots.default()[0].children.length}%`,
      }
    },
  }),
  select: (e) => {
    const selectWidth = e.instance.$el?.clientWidth
    return {
      overlay: {
        style: selectWidth ? `max-width:${selectWidth}px` : '',
      },
      option: {
        style: 'overflow: auto!important; scrollbar-width: none;',
      },
    }
  },
  dialog: (e) => ({
    hooks: {
      onMounted: () => {
        nextTick(() => {
          if (e.instance.mask) {
            const {
              $auth: { permissions },
            } = useNuxtApp()
            const auth = useAuth()
            const isLoggedIn = computed(() => !!auth.value?.token)
            if (isLoggedIn.value && permissions?.value?.['article.update.any']) {
              e.instance.mask.style.top = '3rem'
            }
            e.instance.mask.style.height = '100vh'
            e.instance.mask.style.width = '100vw'
          }
        })
      },
    },
  }),
}

export default PrimeVuePT
